/**
 * This reducer is used for storing GridData
 */
import {
    SAVE_RECEIVE_SETS_DETAILS,
    DELETE_ALL,
    GET_BARCODE_RECEIVE_SETS_SUCCESS,
    GET_BARCODE_RECEIVE_SETS_FAILURE,
    GET_PRODUCT_DETAILS,
    GET_PRODUCT_DETAILS_SUCCESS,
    SET_PRODUCT_DETAILS,
    SET_BARCODE_RECEIVE_SETS,
    CHECK_IS_OUTSIDE_TERRITORY_SUCCESS,
    SAVE_SETS_OUTSIDE_TERRITORY_LIST,
    GET_BARCODE_RECEIVE_SETS,
    RESET_BARCODE_RECEIVE_SETS,
    TERRITORY_SELECTED,
    SHOW_SUCCESS_MESSAGE_POPUP,
    SHOW_INVALID_BARCODE_POPUP,
    SHOW_INVALID_BARCODE_DETAILS,
    SHOW_DCHAIN_BARCODE_DETAILS,
    RESET_TERRITORY_RECEIVE_SETS_DETAILS,
    RESET_INVALID_BARCODE_DETAILS,
    SHOW_D_CHAIN_STATUS_POPUP,
    BULK_BARCODE_DETAILS_DATA,
    RESET_BULK_BARCODE_DETAILS_DATA,
    BULK_EXCLUDED_POPUP_DATA,
    RESET_BULK_EXCLUDED_POPUP_DATA,
    SET_SEARCH_PARAM,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const initialState = {
    receiveSetsListData: [],
    isBarcodeLoading: false,
    barcodeDetails: {},
    productDetails: {},
    isOutsideTerritory: [],
    setsOutsideTerritoryList: [],
    searchParam: '',
    receiveSetUnsavedChangesPopup: false,
    routePathForReceiveSetsUnsavedChangesPopUp: {
        path: '',
        selectOption: '',
    },
    receiveSetsCUInProgress: true,
    territory: '',
    selectedSetNumber: '',
    selectedBatchNumber: '',
    showErrorPopupMessage: false,
    showSuccessPopupMessage: false,
    invalidBarcodeDetails: [],
    dchainBarcodes: [],
    bulkBarcodeDetails: [],
    bulkExcludedData: [],
    showInvalidBarcodePopup: false,
};

const receiveSetsListDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case TERRITORY_SELECTED:
            return {
                ...state,
                territory: action.payload,
            };
        case 'SELECTED_SET_NUMBER':
            return {
                ...state,
                selectedSetNumber: action.payload,
            };
        case 'SELECTED_BATCH_NUMBER':
            return {
                ...state,
                selectedBatchNumber: action.payload,
            };
        case SAVE_RECEIVE_SETS_DETAILS:
            return {
                ...state,
                receiveSetsListData: action.payload,
            };

        case RESET_TERRITORY_RECEIVE_SETS_DETAILS:
            return {
                ...state,
                setsOutsideTerritoryList: [],
            };
        case SHOW_INVALID_BARCODE_POPUP:
            return {
                ...state,
                showInvalidBarcodePopup: action.payload,
            };
        case SHOW_D_CHAIN_STATUS_POPUP:
            return {
                ...state,
                showDChainStatusPopup: action.payload,
            };
        case SHOW_INVALID_BARCODE_DETAILS:
            return {
                ...state,
                invalidBarcodeDetails: action.payload,
            };
        case RESET_INVALID_BARCODE_DETAILS:
            return {
                ...state,
                ...initialState,
            };
        case SHOW_DCHAIN_BARCODE_DETAILS:
            return {
                ...state,
                dchainBarcodes: action.payload,
            };
        case BULK_BARCODE_DETAILS_DATA:
            return {
                ...state,
                bulkBarcodeDetails: action.payload.data,
            };
        case RESET_BULK_BARCODE_DETAILS_DATA:
            return {
                ...state,
                bulkBarcodeDetails: [],
            };
        case BULK_EXCLUDED_POPUP_DATA:
            return {
                ...state,
                bulkExcludedData: action.data,
            };
        case RESET_BULK_EXCLUDED_POPUP_DATA:
            return {
                ...state,
                bulkExcludedData: [],
            };
        case RESET_BARCODE_RECEIVE_SETS:
            return {
                ...state,
                barcodeDetails: {},
            };
        case DELETE_ALL:
            return {
                ...state,
                receiveSetsListData: [],
                setsOutsideTerritoryList: [],
                bulkBarcodeDetails: [],
            };
        case GET_BARCODE_RECEIVE_SETS:
            return {
                ...state,
                isBarcodeLoading: true,
            };
        case GET_BARCODE_RECEIVE_SETS_SUCCESS:
            return {
                ...state,
                barcodeDetails: action.payload,
                isBarcodeLoading: false,
            };
        // case SHOW_ERROR_MESSAGE_POPUP:
        //     return {
        //         ...state,
        //         showErrorPopupMessage: action.payload,
        //     };
        case SHOW_SUCCESS_MESSAGE_POPUP:
            return {
                ...state,
                showSuccessPopupMessage: action.payload,
            };
        case GET_BARCODE_RECEIVE_SETS_FAILURE:
            return {
                ...state,
                barcodeDetails: action.payload,
                isBarcodeLoading: false,
            };
        case GET_PRODUCT_DETAILS:
            return {
                ...state,
                loading: true,
            };
        case GET_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                productDetails: action.payload,
            };
        case SET_BARCODE_RECEIVE_SETS:
            return {
                ...state,
                barcodeDetails: {},
            };
        case SET_PRODUCT_DETAILS:
            return {
                ...state,
                productDetails: {},
            };
        case CHECK_IS_OUTSIDE_TERRITORY_SUCCESS:
            return {
                ...state,
                isOutsideTerritory: action.payload,
            };
        case SAVE_SETS_OUTSIDE_TERRITORY_LIST:
            return {
                ...state,
                setsOutsideTerritoryList: action.payload,
            };
        case SET_SEARCH_PARAM:
            return {
                ...state,
                searchParam: action.payload,
            };
        case 'SET_RECEIVE_UNSAVED_CHANGES_POPUP':
            return {
                ...state,
                receiveSetUnsavedChangesPopup: action.payload,
            };
        case 'SET_ROUTE_PATH_FOR_RECEIVE_SET_UNSAVED_CHANGES_POP_UP':
            return {
                ...state,
                routePathForReceiveSetsUnsavedChangesPopUp: action.payload,
            };
        case 'SET_RECEIVE_SETS_CU_IN_PROGRESS':
            return {
                ...state,
                receiveSetsCUInProgress: action.payload ?? action.data,
            };
        case 'RESET_RECEIVE_SETS_LIST_REDUCER':
            return {
                ...state,
                ...initialState,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'receiveSetsBarcodeDetails',
        storage: storage,
    },
    receiveSetsListDataReducer
);
